<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form
        style="display: none"
        :model="table.where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="$refs.table.reload()"
        @submit.native.prevent
      >
        <el-row :gutter="15">
          <el-col :md="6" :sm="12">
            <el-form-item label="行为名:">
              <el-input v-model.trim="table.where.behaviorName" placeholder="请输入行为名" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询 </el-button>
              <el-button @click="(table.where = {}) && $refs.table.reload()">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 操作按钮 -->
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="add" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加 </el-button>
        <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small">删除 </el-button>
      </div>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="selection" width="45" align="center" fixed="left" />
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="behaviorName" label="行为名" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="score" label="分值" show-overflow-tooltip min-width="110">
            <template #default="{ row }">
              <label v-if="row.scoreStatus == 1">{{ row.score }}</label>
              <label v-else>-{{ row.score }}</label>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip min-width="110" />
          <el-table-column label="操作" width="130px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
              <el-popconfirm title="确定要删除此行为吗？" @onConfirm="remove(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog
      :title="editForm.id ? '修改用户' : '添加用户'"
      :visible.sync="showEdit"
      width="400px"
      @closed="editForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="85px">
        <el-row :gutter="15">
          <el-col>
            <el-form-item label="行为名:" prop="behaviorName">
              <el-input v-model="editForm.behaviorName" placeholder="请输入行为名" clearable />
            </el-form-item>
            <el-form-item label="分值类型:" prop="scoreStatus">
              <el-select v-model="editForm.scoreStatus" placeholder="分值类型" class="ele-block" clearable>
                <el-option label="加分" :value="'1'" />
                <el-option label="减分" :value="'2'" />
              </el-select>
            </el-form-item>
            <el-form-item label="分值:" prop="score">
              <el-input v-model="editForm.score" placeholder="请输入分值" clearable />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="save(editForm.id)">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { deleteBehavior, updateBehavior, saveBehavior, delById } from '../../config/api'; //修改角色权限

  export default {
    name: 'Behavior',
    data() {
      return {
        table: {
          // 表格配置
          url: '/school/behavior/getSchoolBehavior',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [], // 表格选中数据
        showEdit: false, // 是否显示表单弹窗
        editForm: {}, // 表单数据
        editRules: {
          // 表单验证规则
          behaviorName: [{ required: true, message: '请输入行为名', trigger: 'blur' }],
          score: [{ required: true, message: '请输入分值', trigger: 'blur' }],
        },
        showImport: false, // 显示导入弹窗
        uploadLoading: false, // 导入加载状态
      };
    },
    mounted() {},
    methods: {
      // 显示添加
      add() {
        this.showEdit = true;
      },
      /* 显示编辑 */
      edit(row) {
        // if(this.choose[0].roles[0].administrator == '1') return this.$message.error('不能更改除初始管理员');
        this.editForm = Object.assign({}, row, {});
        this.showEdit = true;
      },
      /* 保存编辑 */
      save(userId) {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            if (userId == undefined) {
              //添加教师
              // formData.append("avatar", this.imagefile);
              saveBehavior(formData)
                .then((res) => {
                  loading.close();
                  if (res.data.resCode == 200) {
                    this.showEdit = false;
                    this.$message({ type: 'success', message: res.data.resMsg });
                    this.$refs.table.reload();
                  } else {
                    this.$message.error(res.data.resMsg);
                  }
                })
                .catch((e) => {
                  loading.close();
                  this.$message.error(e.message);
                });
            } else {
              //编辑角色
              updateBehavior(formData)
                .then((res) => {
                  loading.close();
                  if (res.data.resCode == 200) {
                    this.showEdit = false;
                    this.$message({ type: 'success', message: res.data.resMsg });
                    this.$refs.table.reload();
                  } else {
                    this.$message.error(res.data.resMsg);
                  }
                })
                .catch((e) => {
                  loading.close();
                  this.$message.error(e.message);
                });
            }
          } else {
            return false;
          }
        });
      },
      /* 删除 */
      remove(row) {
        if (!row) {
          // 批量删除
          if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
          // if(this.choose[0].roles[0].administrator == '1') return this.$message.error('不能删除初始管理员');
          let ids = this.choose.map((d) => d.id);
          this.$confirm('确定要删除选中的数据吗?', '提示', { type: 'warning' })
            .then(() => {
              const loading = this.$loading({ lock: true });
              let formData = new FormData();
              formData.append('ids', ids);
              formData.append('state', -1);
              deleteBehavior(formData)
                .then((res) => {
                  loading.close();
                  if (res.data.resCode == 200) {
                    this.$message({ type: 'success', message: res.data.resMsg });
                    this.$refs.table.reload();
                  } else {
                    this.$message.error(res.data.resMsg);
                  }
                })
                .catch((e) => {
                  loading.close();
                  this.$message.error(e.message);
                });
            })
            .catch(() => 0);
        } else {
          // 单个删除
          // if(this.choose[0].roles[0].administrator == '1') return this.$message.error('不能删除初始管理员');
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          formData.append('id', row.id);
          formData.append('state', -1);
          delById(formData)
            .then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            })
            .catch((e) => {
              loading.close();
              this.$message.error(e.message);
            });
        }
      },
    },
  };
</script>

<style scoped>
  .ele-block >>> .el-upload,
  .ele-block >>> .el-upload-dragger {
    width: 100%;
  }
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    /*height: calc(100vh - 262px);*/
    height: 55vh;
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 40px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
</style>
